import React from 'react';
import { getTabList } from './tabs';
import { Tabs } from '../../styles';
import useReviewTabs from './hooks/useReviewTabs';
import { FORM_TAB_GROUP_ARIA_LABEL } from '../constants';
export var REVIEW_FORM_TAB_ID = 'review-form-tabs';
var ReviewForm = function ReviewForm(_ref) {
  var citation = _ref.citation;
  var _useReviewTabs = useReviewTabs({
      intialPubtypeState: citation === null || citation === void 0 ? void 0 : citation.data.pubtype
    }),
    activeTabIndex = _useReviewTabs.activeTabIndex,
    handleTabChange = _useReviewTabs.handleTabChange;
  return /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabList(activeTabIndex),
    activeTabIndex: activeTabIndex,
    id: REVIEW_FORM_TAB_ID,
    onChangeIndex: handleTabChange,
    "aria-label": FORM_TAB_GROUP_ARIA_LABEL,
    "data-test": REVIEW_FORM_TAB_ID
  });
};
export default ReviewForm;